export default "/images/ff0673f3ce2961164a29771a9a41a8cf.avif";